import React, { Dispatch, SetStateAction } from 'react';

import { Icon, IconButton } from '@atom/mui';
import colors from '@atom/styles/colors';
import history from '@atom/utilities/history';

import { View } from './SearchPortal';

import './searchPortal.css';

interface Props {
  query: string;
  setActiveView: Dispatch<SetStateAction<View>>;
  activeView: string;
}

const SearchPortalHeader = ({ query, activeView, setActiveView }: Props) => {
  return (
    <div styleName="search-portal-header">
      <div styleName="back-container">
        <IconButton onClick={() => history.goBackWithState('/')}>
          <Icon>arrow_back</Icon>
        </IconButton>
        <div>
          Search Results: <span styleName="query-display">{query}</span>
        </div>
      </div>
      <div styleName="navigation-row">
        <div
          styleName="tab-container"
          onClick={() => setActiveView(View.ALL)}
          style={{
            color:
              activeView === View.ALL ? colors.brand.blue : colors.neutral.dark,
          }}
        >
          ALL RESULTS
        </div>
        <div
          styleName="tab-container"
          onClick={() => setActiveView(View.INVENTORY)}
          style={{
            color:
              activeView === View.INVENTORY
                ? colors.brand.blue
                : colors.neutral.dark,
          }}
        >
          INVENTORY
        </div>
        <div
          styleName="tab-container"
          onClick={() => setActiveView(View.WORK)}
          style={{
            color:
              activeView === View.WORK
                ? colors.brand.blue
                : colors.neutral.dark,
          }}
        >
          WORK
        </div>
        <div
          styleName="tab-container"
          onClick={() => setActiveView(View.USERS)}
          style={{
            color:
              activeView === View.USERS
                ? colors.brand.blue
                : colors.neutral.dark,
          }}
        >
          TEAM
        </div>
      </div>
    </div>
  );
};

export default SearchPortalHeader;
